// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("./IOUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var FunctionUtils = require("./FunctionUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");

function useState(intitalState) {
  var match = React.useState(function () {
        return Curry._1(intitalState, undefined);
      });
  var set = match[1];
  var set$1 = React.useCallback((function (newState) {
          return Curry._2(Relude_IO.mapError, (function (prim) {
                        
                      }), Relude_IO.suspend(function (param) {
                          return Curry._1(set, (function (param) {
                                        return newState;
                                      }));
                        }));
        }), []);
  return [
          match[0],
          set$1
        ];
}

function useMappableState(intitalState) {
  var match = React.useState(function () {
        return Curry._1(intitalState, undefined);
      });
  var set = match[1];
  var set$1 = React.useCallback((function (newStateFn) {
          return Curry._2(Relude_IO.mapError, (function (prim) {
                        
                      }), Relude_IO.suspend(function (param) {
                          return Curry._1(set, newStateFn);
                        }));
        }), []);
  return [
          match[0],
          set$1
        ];
}

function useReducer(reducer, initialState) {
  var param = React.useReducer(Curry.__2(reducer), initialState);
  var dispatch = param[1];
  return [
          param[0],
          (function (action) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Relude_IO.suspend(function (param) {
                              return Curry._1(dispatch, action);
                            }));
            })
        ];
}

function useIOWrapper(onUnmount, onFinish, io) {
  var ioResult = {
    contents: undefined
  };
  Relude_IO.unsafeRunAsync((function (result) {
          ioResult.contents = Relude_Option.pure(result);
          return Relude_Option.getOrElse(undefined, Relude_Option.apply(onFinish, Relude_Option.pure(result)));
        }), io);
  return (function (param) {
            return IOUtils.unsafeRunHandledAsync(Relude_Option.getOrElseLazy(Relude_IO.pure, Relude_Option.apply(onUnmount, ioResult.contents)));
          });
}

function useEffect0(onUnmount, onFinish, io) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, io);
        }), []);
  
}

function useEffect1(onUnmount, onFinish, io, arg) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, Curry._1(io, arg));
        }), Relude_Array.pure(arg));
  
}

function useEffect2(onUnmount, onFinish, io, args) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, Relude_Function.uncurry2(io, args));
        }), args);
  
}

function useEffect3(onUnmount, onFinish, io, args) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, Relude_Function.uncurry3(io, args));
        }), args);
  
}

function useEffect4(onUnmount, onFinish, io, args) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, Relude_Function.uncurry4(io, args));
        }), args);
  
}

function useEffect5(onUnmount, onFinish, io, args) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, Relude_Function.uncurry5(io, args));
        }), args);
  
}

function useEffect6(onUnmount, onFinish, io, args) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, FunctionUtils.uncurry6(io, args));
        }), args);
  
}

function useEffect7(onUnmount, onFinish, io, args) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, FunctionUtils.uncurry7(io, args));
        }), args);
  
}

function useEffect8(onUnmount, onFinish, io, args) {
  React.useEffect((function () {
          return useIOWrapper(onUnmount, onFinish, FunctionUtils.uncurry8(io, args));
        }), args);
  
}

function useLayoutEffect0(onUnmount, onFinish, io) {
  React.useLayoutEffect((function () {
          return useIOWrapper(onUnmount, onFinish, io);
        }), []);
  
}

function useLayoutEffect1(onUnmount, onFinish, io, arg) {
  React.useLayoutEffect((function () {
          return useIOWrapper(onUnmount, onFinish, Curry._1(io, arg));
        }), Relude_Array.pure(arg));
  
}

function useLayoutEffect2(onUnmount, onFinish, io, args) {
  React.useLayoutEffect((function () {
          return useIOWrapper(onUnmount, onFinish, Relude_Function.uncurry2(io, args));
        }), args);
  
}

var arg = (function (param) {
    return Relude_Result.fold(Relude_Globals.id, Relude_Globals.id, param);
  });

function useHandledIOOnMount(param) {
  return function (param$1) {
    return useEffect0(param, arg, param$1);
  };
}

function useIOOnUnmount(onUnmount) {
  return useHandledIOOnMount((function (param) {
                  return Relude_Globals.$$const(onUnmount, param);
                }))(Relude_IO.pure(undefined));
}

function repeatIOWhileMounted(intervalMs, io) {
  return useEffect0((function (param) {
                return Relude_Result.fold(Relude_IO.pure, Relude_IO.suspend, param);
              }), undefined, IOUtils.runIOUntilCancelled(intervalMs, io));
}

function useMemo0(prim) {
  return React.useMemo((function () {
                return Curry._1(prim, undefined);
              }), []);
}

function useMemo1(fn, memoizedProps) {
  return React.useMemo((function () {
                return Curry._1(fn, memoizedProps);
              }), Relude_Array.pure(memoizedProps));
}

function useMemo2(fn, memoizedProps) {
  return React.useMemo((function () {
                return Relude_Function.uncurry2(fn, memoizedProps);
              }), memoizedProps);
}

function useMemo3(fn, memoizedProps) {
  return React.useMemo((function () {
                return Relude_Function.uncurry3(fn, memoizedProps);
              }), memoizedProps);
}

function useMemo4(fn, memoizedProps) {
  return React.useMemo((function () {
                return Relude_Function.uncurry4(fn, memoizedProps);
              }), memoizedProps);
}

function useMemo5(fn, memoizedProps) {
  return React.useMemo((function () {
                return Relude_Function.uncurry5(fn, memoizedProps);
              }), memoizedProps);
}

function useMemo6(fn, memoizedProps) {
  return React.useMemo((function () {
                return FunctionUtils.uncurry6(fn, memoizedProps);
              }), memoizedProps);
}

function useMemo7(fn, memoizedProps) {
  return React.useMemo((function () {
                return FunctionUtils.uncurry7(fn, memoizedProps);
              }), memoizedProps);
}

function useMemo8(fn, memoizedProps) {
  return React.useMemo((function () {
                return FunctionUtils.uncurry8(fn, memoizedProps);
              }), memoizedProps);
}

function getCurrentRef(param) {
  return Caml_option.nullable_to_opt(param.current);
}

function useRef(setter) {
  var genericRef = React.useRef(null);
  var refInIO = useMemo1((function (param) {
          return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                        return Relude_IO.map(getCurrentRef, param);
                      }), param);
        }), genericRef);
  return [
          refInIO,
          Curry._1(setter, genericRef)
        ];
}

function useDomRef(param) {
  return useRef(function (prim) {
              return prim;
            });
}

function useNativeRef(param) {
  return useRef(function (prim) {
              return prim;
            });
}

var useIOOnMount = useEffect0;

exports.useState = useState;
exports.useMappableState = useMappableState;
exports.useReducer = useReducer;
exports.useEffect0 = useEffect0;
exports.useEffect1 = useEffect1;
exports.useEffect2 = useEffect2;
exports.useEffect3 = useEffect3;
exports.useEffect4 = useEffect4;
exports.useEffect5 = useEffect5;
exports.useEffect6 = useEffect6;
exports.useEffect7 = useEffect7;
exports.useEffect8 = useEffect8;
exports.useLayoutEffect0 = useLayoutEffect0;
exports.useLayoutEffect1 = useLayoutEffect1;
exports.useLayoutEffect2 = useLayoutEffect2;
exports.useIOOnMount = useIOOnMount;
exports.useHandledIOOnMount = useHandledIOOnMount;
exports.useIOOnUnmount = useIOOnUnmount;
exports.repeatIOWhileMounted = repeatIOWhileMounted;
exports.useMemo0 = useMemo0;
exports.useMemo1 = useMemo1;
exports.useMemo2 = useMemo2;
exports.useMemo3 = useMemo3;
exports.useMemo4 = useMemo4;
exports.useMemo5 = useMemo5;
exports.useMemo6 = useMemo6;
exports.useMemo7 = useMemo7;
exports.useMemo8 = useMemo8;
exports.useRef = useRef;
exports.useDomRef = useDomRef;
exports.useNativeRef = useNativeRef;
/* react Not a pure module */
